import { steps } from "@/mocks/comics";

export default function HowItWorks() {
  return (
    <section id="how" className="relative overflow-hidden bg-primary-950 py-14 md:py-20">
      <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-primary-500/20 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-20 -left-10 h-64 w-64 rounded-full bg-accent-500/20 blur-3xl"></div>

      <div className="relative mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-accent-400">
            <i className="ri-rocket-2-line"></i> 三步上手
          </span>
          <h2 className="mt-2 font-heading text-2xl text-background-50 md:text-4xl">
            这样追更，不再错过最新话
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-background-200/90 md:text-base">
            不用再到处翻评论问进度，收藏后每次打开都能看到有没有新章节，连载进度一目了然。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {steps.map((s, i) => (
            <div
              key={s.title}
              className="relative rounded-lg border border-background-50/10 bg-background-50/5 p-6 backdrop-blur-sm"
            >
              <span className="absolute right-5 top-4 font-heading text-4xl text-background-50/10">
                0{i + 1}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className={`${s.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-5 text-lg font-bold text-background-50">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-200/85">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}